@if (transaction(); as transaction) {
  <div class="rounded-b-[10px] px-4 pb-4 pt-3 -mx-4 mb-3"
       [class.bg-[#C92F29]]="transaction.riskScore === 'SEVERE'"
       [class.bg-[#EA3D3D]]="transaction.riskScore === 'HIGH'"
       [class.bg-[#FFCB10]]="transaction.riskScore === 'MEDIUM'"
       [class.bg-[#87C05A]]="transaction.riskScore === 'LOW'"
  >
    <h3 class="relative px-[30px] !font-bold !text-[18px] leading-[1.2] mb-3 text-center"
        [ngClass]="transaction.riskScore === 'MEDIUM' ? 'text-[#022D35]' : 'text-white'">
      Incoming Transaction Report
    </h3>
    <div class="px-[11px] mb-[2px]">
      <p
        class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px] border-t border-solid border-[#022D35] border-opacity-10">
        <span class="opacity-70"
              [ngClass]="{
          'text-[#022D35]': transaction.riskScore === 'MEDIUM',
          'text-white': transaction.riskScore !== 'MEDIUM'
          }">ID</span>
        <span class="opacity-70"
              [ngClass]="{
          'text-[#022D35]': transaction.riskScore === 'MEDIUM',
          'text-white': transaction.riskScore !== 'MEDIUM'
          }">{{ transaction.id }}</span>
      </p>
      <p
        class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px] border-t border-solid border-[#022D35] border-opacity-10">
        <span class="opacity-70"
              [ngClass]="{
          'text-[#022D35]': transaction.riskScore === 'MEDIUM',
          'text-white': transaction.riskScore !== 'MEDIUM'
          }">Report Time</span>
        <span class="opacity-70"
              [ngClass]="{
          'text-[#022D35]': transaction.riskScore === 'MEDIUM',
          'text-white': transaction.riskScore !== 'MEDIUM'
          }">{{ transaction.timeCreated | date: 'h:mm a, dd/MM/yy' }}</span>
      </p>
    </div>
    <div class="bg-white flex flex-col rounded-[8px] shadow-3 border border-solid border-black mb-3">
      <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
        <img class="w-[30px] h-[30px] mr-[7px]"
             [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
        <div class="min-w-[38px] flex flex-col mr-3">
          <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
          <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
        </div>
        <div class="flex flex-col mr-3">
          <span class="text-[12px] leading-[1.2] mb-1 mt-[1px]">Sender:</span>
          <span class="flex items-center pt-[1px]">
            <span
              class="text-[#7A9095] text-[14px] leading-[1] mr-1">{{ transaction.addressFrom | cropWithDotsCenter: 6 : 6 }}</span>
            <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressFrom"
                             [size]="'small'"></app-copy-button>
          </span>
        </div>
      </div>
      <div class="flex justify-start py-3 pr-3 pl-4">
        <img class="mr-[15px]" ngSrc="assets/icons/arrow-down-new.svg" alt="arrow" height="78" width="18">
        <div class="flex flex-col">
          <span class="text-[12px] leading-[1.2]">Amount Received:</span>
          <span class="leading-[1.2] text-[26px] tracking-[-0.45px] font-medium mb-2">
            @switch (transaction.coin) {
              @case ('USDT') {
                {{ (transaction.amount | cutNumber:('1.2-2')) ?? '0.00' }}
              }
              @default {
                {{ (transaction.amount | cutNumber:('1.2-8')) ?? '0.00' }}
              }
            }
            {{ transaction.coin }}
          </span>
          <span class="text-[#7A9095] text-[12px] leading-[1.2] mb-[2px]">Hash:</span>
          <span class="flex items-center">
            <span
              class="text-[#7A9095] text-[14px] leading-[1]">{{ transaction.target | cropWithDotsCenter:14:14 }}</span>
            <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" class="ml-1" [value]="transaction.target"
                             [size]="'small'"></app-copy-button>
          </span>
        </div>
      </div>
      <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
        <img class="w-[30px] h-[30px] mr-[7px]"
             [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
        <div class="min-w-[38px] flex flex-col mr-3">
          <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
          <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
        </div>
        <div class="flex flex-col mr-3">
          <span class="flex text-[12px] leading-[1.2] mb-1 mt-[1px]">
            <span class="mr-3">Receiver:</span>
            @if (transaction.type === 'INCOMING') {
              <span class="font-bold">My wallet: {{ transaction.walletName }}</span>
            }
          </span>
          <span class="flex items-center pt-[1px]">
            <span
              class="text-[#7A9095] leading-[1] text-[14px] mr-1">{{ transaction.addressTo | cropWithDotsCenter:10:10 }}</span>
            <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressTo"
                             [size]="'small'"></app-copy-button>
          </span>
        </div>
      </div>
    </div>
    <div class="flex items-center mb-[7px]">
      <div class="pl-3 mr-[7px]">
        <img class="min-w-[30px] h-[30px]"
             [ngSrc]="'assets/icons/round-risk-' + (transaction.riskScore | lowercase) + '.svg'" alt="arrow" height="30"
             width="30">
      </div>
      <span class="text-[16px] font-bold"
            [ngClass]="{
        'text-[#022D35]': transaction.riskScore === 'MEDIUM',
        'text-white': transaction.riskScore !== 'MEDIUM'
        }">
        @switch (transaction.riskScore) {
          @case ('SEVERE') {
            Severe Risk Level
          }
          @case ('HIGH') {
            High Risk Level
          }
          @case ('MEDIUM') {
            Medium Risk Level
          }
          @case ('LOW') {
            Low Risk Level
          }
        }
      </span>
    </div>
    @if (transaction.riskScore !== 'LOW') {
      <div class="flex flex-col pl-[48px]"
           [ngClass]="{
        'text-[#022D35]': transaction.riskScore === 'MEDIUM',
        'text-white': transaction.riskScore !== 'MEDIUM'
        }">
        <span class="text-[12px] leading-[1.2]">Risky Amount:</span>
        <span class="text-[26px] leading-[1.2] mb-3">
          {{ transaction.riskyAmount| cutNumber:('1.2-2') }} USDT
        </span>
        <a target="_blank" href="https://t.me/AMLOfficer_support_bot"
           class="flex justify-center items-center min-h-[39px] w-full border border-solid"
           [ngClass]="{
          'text-[#022D35] border-[#022D35]': transaction.riskScore === 'MEDIUM',
          'text-white border-white': transaction.riskScore !== 'MEDIUM'
          }" mat-raised-button mat-button color="primary">
          @if (transaction.riskScore === 'MEDIUM') {
            Ask AML Officer
          } @else {
            Earn 7% on Recovery of Stolen Funds
          }
        </a>
      </div>
    }
  </div>


  @if ((transaction.type === 'INCOMING' || transaction.type === 'TRANSACTION_SCAN') && asIngoingTransaction(transaction); as
    ingoingTransaction) {
    @if (ingoingTransaction.latestAmlReport.alerts && ingoingTransaction.latestAmlReport.alerts.length > 0) {
      <div class="flex justify-between items-center w-full py-1 mb-3">
        <span class="text-[10px] font-bold uppercase min-w-fit max-w-fit w-full mr-1">AML Triggers</span>
        <span class="h-[1px] w-full bg-[#022D35]"></span>
        <app-info class="w-[14px] h-[14px] ml-1" [currentColor]="'text-[#9AABAE]'" [text]="'AML Triggers'"></app-info>
      </div>

      @for (alert of ingoingTransaction.latestAmlReport.alerts; track $index) {
        <div
          class="flex justify-between items-start pb-[6px] mb-[6px] border-b border-solid border-black border-opacity-5 last:pb-0 last:mb-0 last:border-none">
          <div class="flex flex-col items-start">
            <span class="leading-[1.3] font-bold text-[#234542]">
              {{ alert.categoryId | triggerIdConvertToCategory | titlecase }}
            </span>
            <span class="leading-[1.2] text-[11px] text-[#567474] mr-1 flex items-center">
              <span class="mr-1">{{ alert.alertAmount | cutNumber:('1.2-2') }} USDT</span>
              <span
                class="text-[11px] font-medium text-[#45525B] rounded-[60px] bg-[#23454233] px-1 py-[2px]">{{ calcPercentForExposures(+alert.alertAmount) }}
                %</span>
            </span>
            <span
              class="uppercase text-[12px] font-medium rounded-[60px] min-h-[15px] px-[6px] flex justify-center items-center"
              [ngClass]="{
                'border border-solid border-[#C92F29] text-[#C92F29]': alert.exposureType === 'INDIRECT',
                'bg-[#C92F29] text-white': alert.exposureType !== 'INDIRECT'
              }"
            >
            {{ alert.exposureType | titlecase }}
            </span>
          </div>
          <div>
            <app-report-status [risk]="alert.alertLevel"></app-report-status>
          </div>
        </div>
      }
    }
  }
}
